{
	"page": {
		"title": "Affiliated Organizations",
		"intro": "Who the card holder works for — a press agency, sponsor or broadcaster. Distinct from the <strong>responsible organization</strong>, which owns the registration.",
		"addOrganization": "Add organization",
		"count_one": "{{n}} organization",
		"count_other": "{{n}} organizations"
	},
	"filters": {
		"searchPlaceholder": "Search organizations by name",
		"typeChips": "Type"
	},
	"table": {
		"name": "Name",
		"type": "Type",
		"cards": "Cards",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"cardsTitle": "Cards naming this organization",
		"noTypeTitle": "No type set"
	},
	"type": {
		"SPONSOR": "Sponsor",
		"BROADCASTER": "Broadcaster",
		"MEDIA_HOUSE": "Media house",
		"OTHER": "Other"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} organization",
		"summary_other": "{{from}}–{{to}} of {{total}} organizations",
		"empty": "No organizations"
	},
	"empty": {
		"filteredTitle": "No organizations match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No affiliated organizations yet",
		"noneDescription": "Add the press agencies, sponsors and broadcasters card holders work for.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add organization",
		"addDescription": "Registrars pick from this list when a card holder works for a press agency, sponsor or broadcaster.",
		"addSubmit": "Add organization",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} card names this organization — a change shows on it immediately.",
		"editInUse_other": "{{count}} cards name this organization — a change shows on them immediately.",
		"editEmpty": "No cards name this organization yet.",
		"field": {
			"name": "Name",
			"nameHint": "As it should read on lists and cards — Reuters, Astro, Milo.",
			"type": "Type",
			"typeHint": "Optional — a coarse label for filtering."
		},
		"placeholder": {
			"name": "Reuters",
			"type": "No type"
		}
	},
	"delete": {
		"title": "Delete organization",
		"description": "Delete <strong>{{name}}</strong>? This only works while no cards name it.",
		"confirm": "Delete organization",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete organization"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add organization",
		"updateFailed": "Couldn't update organization"
	},
	"errors": {
		"nameTaken": "An organization with that name already exists.",
		"invalidValue": "Invalid value"
	},
	"stats": {
		"total": "Organizations",
		"matching": "matching the filters",
		"noType": "No type"
	}
}
